// Single source of truth for switching the UI language (2026-08).
//
// Since language is now decided by the URL / explicit choice (see i18n.js),
// changing the language must:
//   1. update i18next (runtime content),
//   2. mark the choice as EXPLICIT (so the language-suggestion banner never
//      nags a user who already picked a language),
//   3. reflect the choice in the address bar via `?lng=xx` — so shared links
//      open in the same language for everyone (pt = clean URL, no param).
//
// Used by both LanguageSwitcher and the LanguageBanner suggestion.

export const SUPPORTED_LANGS = ["pt", "en", "es", "fr"];
export const LANG_EXPLICIT_KEY = "mototrips_lang_explicit";

export function applyLanguage(i18n, lng) {
  if (!SUPPORTED_LANGS.includes(lng)) lng = "pt";
  i18n.changeLanguage(lng);
  try {
    localStorage.setItem(LANG_EXPLICIT_KEY, lng);
  } catch (e) {
    /* private mode / storage disabled — non-fatal */
  }
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete("lang"); // legacy param cleanup
    if (lng === "pt") url.searchParams.delete("lng");
    else url.searchParams.set("lng", lng);
    window.history.replaceState({}, "", url.toString());
  } catch (e) {
    /* non-fatal */
  }
}
